import SelectMui, { SelectProps } from '@mui/material/Select';

export function Select(props: SelectProps) {
    return <SelectMui data-testid={'select-container'} {...props} />;
}

export default Select;
